import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AdminLayout } from "./components/AdminLayout";
import { Login } from "./screens/Login";
import { AdminLogin } from "./screens/AdminLogin";
import { Leads } from "./screens/Leads";
import { Delivery } from "./screens/Delivery";
import { Team } from "./screens/Team";
import { Settings } from "./screens/Settings";
import { AdminBrands } from "./screens/AdminBrands";
import { AdminBrandSetup } from "./screens/AdminBrandSetup";
import { AdminManualLead } from "./screens/AdminManualLead";
import { AdminSettings } from "./screens/AdminSettings";
import { AdminAudit } from "./screens/AdminAudit";
import { AdminDeliveryHealth } from "./screens/AdminDeliveryHealth";
import { AccountSetup } from "./screens/AccountSetup";
import { DestinationVerification } from "./screens/DestinationVerification";
import { InvitationVerification } from "./screens/InvitationVerification";
import { PasswordReset } from "./screens/PasswordReset";

const AdminPerformance = lazy(() =>
  import("./screens/AdminPerformance").then((module) => ({ default: module.AdminPerformance })),
);

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/account-setup" element={<AccountSetup />} />
      <Route path="/reset-password" element={<PasswordReset />} />
      <Route path="/destination-verification" element={<DestinationVerification />} />
      <Route path="/invitation-verification" element={<InvitationVerification />} />

      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<AdminBrands />} />
        <Route
          path="/admin/performance"
          element={
            <Suspense
              fallback={
                <div className="rounded-md border border-default bg-surface-white py-24 text-center text-body text-tertiary">
                  Loading client performance…
                </div>
              }
            >
              <AdminPerformance />
            </Suspense>
          }
        />
        <Route path="/admin/brands/new" element={<AdminBrandSetup />} />
        <Route path="/admin/leads/new" element={<AdminManualLead />} />
        <Route path="/admin/delivery" element={<AdminDeliveryHealth />} />
        <Route path="/admin/audit" element={<AdminAudit />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
      </Route>

      <Route element={<Layout />}>
        <Route path="/" element={<Leads />} />
        <Route path="/delivery" element={<Delivery />} />
        <Route path="/team" element={<Team />} />
        <Route path="/settings" element={<Settings />} />
        <Route
          path="*"
          element={
            <div className="py-[120px] text-center">
              <h2 className="text-title-md font-bold text-primary mb-2">Page not found</h2>
              <a href="/" className="text-body text-brand-red hover:underline">
                Back to Leads
              </a>
            </div>
          }
        />
      </Route>
    </Routes>
  );
}
